import React, { useEffect } from 'react'
import { Row, Col, Label } from 'reactstrap'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { format } from 'utils/stringUtilities'
import { withDialogs, dialogTypes } from 'decorators'
import { LoadingIndicator } from 'components/loading'
import { Button } from 'components/buttons'
import WineForm from 'pages/wines/form'
import { api } from 'store/modules/wines'
import { useStyles } from './wineDetails.css'

export const WineDetails = React.memo(withDialogs(({ localize, wineId, showDialog, onWineUpdate }) => {
  const { getEntity } = api
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [entity, setEntity] = React.useState(null)
  const handleExpandChange = React.useCallback((_, newExpanded) => setExpanded(newExpanded), [setExpanded])
  const handleUpdateWineForm = React.useCallback(_ => {}, []) 
  
  const handleEditWine = React.useCallback(e => {
    e.stopPropagation()
    showDialog({
      dialogType: dialogTypes.wineDetail, 
      context: { 
        entity: { id: wineId },
        onSaved: x => {
          setEntity(x.entity)
          onWineUpdate()
        }
      }
    })
  }, [wineId, onWineUpdate, showDialog])

  useEffect(() => {
    if (wineId > 0) {
      setLoading(true)
      getEntity(wineId)
        .then(response => {
          setEntity(response)
        })
        .catch(() => showDialog({
          dialogType: dialogTypes.alert,
          context: { message: 'Došlo k neznámé chybě. Prosím, zkuste to později.' }
        }))
        .finally(() => setLoading(false))
    }
  }, [wineId, getEntity, showDialog])
  return (
    <Row>
      <Col sm={12}>
        <div className={classes.wine}>
          <Accordion expanded={expanded} onChange={handleExpandChange}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classes.summary}
              aria-controls={`panel-content`}
              id={`panel-header`}>
              {loading && <LoadingIndicator />}
              {!loading && !(wineId > 0) && <Label className={classes.label}>{localize('bottles.pleaseSelectWine')}</Label>}
              {!loading && entity && <React.Fragment>
                {wineId > 0 && <Label className={classes.label}>{format(localize('bottles.wineTitle'), entity.bottlesCount)}</Label>}
                <div className={classes.editWine}>
                  <Button className={classes.button} disabled={!(wineId > 0)} onClick={handleEditWine} icon='pencil'>{localize('bottles.editWine')}</Button>
                </div>
              </React.Fragment>} 
            </AccordionSummary>
            <AccordionDetails>
              {!loading && entity && wineId > 0 && <WineForm data={{ entity }} disabled localize={localize} updateEntity={handleUpdateWineForm} />}
            </AccordionDetails>
          </Accordion>
        </div>
      </Col>
    </Row>
  )
}))
